import { Injectable } from '@angular/core';
import { AppStateService } from '@siza-staff-care/shared/app-state';
import { GenericDialogsService } from '@siza-staff-care/shared/generic-dialogs';
import { Observable, map, tap } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class PreventActivateForSmallScreenGuard {
	constructor(
		private appState: AppStateService,
		private genericDialogs: GenericDialogsService,
	) {}

	canActivate(): Observable<boolean> {
		return this.appState.isHandset$.pipe(
			tap((isHandset) => {
				if (isHandset) {
					this.genericDialogs.message({
						title: 'Sorry',
						message: 'This content is not available on devices with small screens',
					});
				}
			}),
			map((isHandset) => {
				return !isHandset;
			}),
		);
	}
}
